export enum ControllerChangeEventType {
  Connection = 'Connection',
  Button = 'Button',
  Touchpad = 'Touchpad'
}